import { observable } from "mobx";
import { Type } from "class-transformer";
import DistributorRefundApprovalPermittedActionResponse from "./distributorRefundApprovalPermittedActionResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class DistributorRefundCandidatePermittedActionsResponse {
  @observable
  @Type(() => DistributorRefundApprovalPermittedActionResponse)
  refundApproval!: DistributorRefundApprovalPermittedActionResponse;
}
